import { ServiceDocsData, SpecData } from 'src/models';
import React from 'react';
import { strings } from 'src/localization';
import css from './Logo.module.scss';
import { ReactComponent as GM } from 'src/content/images/Makes/GM.svg';
import { ReactComponent as KiaLanding } from 'src/content/images/Makes/KiaLanding.svg';
// import { ReactComponent as Mazda } from 'src/content/images/Makes/Mazda.svg';
import VehicleMakeImages from '../VehicleImages/VehicleMakeImages';
import { CheckIn } from 'src/content/icons';
import { checkSpecTheme } from 'src/helpers/OEMHelper/OEMHelper';
import lexusWhite from 'src/content/images/Makes/Lexus-Logo-White.svg';

interface IProps {
    specData?: SpecData;
    serviceDocsData?: ServiceDocsData;
    theme: string;
    menuLogo?: boolean;
    landingLogo?: boolean;
}

const Logo = (props: IProps) => {
    let theme = props.theme;
    let cssNoImgLogo = css.noImgLogo;
    if (props.theme === 'colorSensitive' && (props.specData || props.serviceDocsData)) {
        const specsTheme = props.specData?.oemTheme ?? '';
        const serviceSpecsTheme = props.serviceDocsData?.theme ?? '';
        theme = checkSpecTheme(specsTheme || serviceSpecsTheme);

        if (!props.menuLogo) {
            cssNoImgLogo = css.noImgLogoADA;
        }
        if (theme==='bmw' && props.menuLogo) {
            theme='bmw color sensitive';
        }
        if (theme === 'acura' || theme === 'acura-CA') {
            theme = 'acura color sensitive';
        }
        if (theme === 'honda' || theme === 'honda-CA') {
            theme = 'honda color sensitive';
        }
        if (theme === 'infiniti') {
            theme = 'infiniti color sensitive';
        }
        if (theme === 'porsche' && props.landingLogo) {
            theme = 'porsche color sensitive';
        }
        if (theme === 'lexusMonogram') {
            theme = 'lexus monogram color sensitive';
        }
    }
    let ImageType: 'menuLogo' | 'thumb' | 'landingLogo' | undefined = props.menuLogo ? 'menuLogo' : undefined;
    if (props.landingLogo) {
        ImageType = 'landingLogo';
    }
    let logoImage = (<VehicleMakeImages make={theme} type={ImageType} specData={props.specData} theme={props.theme}
        serviceDocsData={props.serviceDocsData}/>);
    if (props.specData?.logImgName) {
        logoImage = (<img
            id='customImage'
            className={css.customLogo}
            alt={strings.DealerLogo}
            src={props.specData?.logImgName}
            title={strings.DealerLogo}
        />);
    }
    // If GM, Custom Logo not selected by user or undefined, the menu and landing logo switch logoImage
    // to use the svg comp for that image.
    if (ImageType === 'menuLogo' && theme === 'gm' && !props.specData?.logImgName) {
        logoImage = <GM className={css.gmLogo} />;
    }
    if (ImageType === 'landingLogo' && theme === 'gm' && !props.specData?.logImgName) {
        logoImage = <GM className={css.gmLandingLogo} />;
    }
    if (ImageType === 'landingLogo' && theme === 'kia'&& !props.specData?.logImgName) {
        logoImage = <KiaLanding className={css.kiaLandingLogo} />;
    }
    // if (ImageType === 'landingLogo' && theme === 'mazda') {
    //     logoImage = <Mazda className={css.kiaLandingLogo} />;
    // }
    // If theme is colorSensitive, use white Lexus logo
    if (ImageType === 'landingLogo' && theme === 'lexus' && !props.specData?.logImgName) {
        logoImage = (<img
            id='customImage'
            className={css.logo}
            alt={strings.DealerLogo}
            src={lexusWhite}
            title={strings.DealerLogo}
        />);
    }
    // The logic below is used by OEMs when they do not have a logo.
    // Keep the logic commented out when not in use, just in case we have another case of an OEM without logo
    // (ImageType === 'menuLogo' ||
    if ((ImageType === 'landingLogo') && (theme === 'mercedesBenz')) {
        logoImage = <CheckIn className={cssNoImgLogo} />;
    }

    return (
        <div>
            { theme === 'normal' && !props.specData?.logImgName ?
                <CheckIn className={cssNoImgLogo} />: logoImage
            }
        </div>
    );
};

export default Logo;
